
import { TileBlueprintSupported } from "../shared/tile/tile.component";
import { DefaultBlueprintComponent } from "./default-blueprint/default-blueprint.component";

export const mapping = {
  default: DefaultBlueprintComponent,
  whatever: DefaultBlueprintComponent
} satisfies Record<string, new () => TileBlueprintSupported>;